import React from 'react';

import TagValueViewer from 'metadata/TagValueViewer';
import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import {ChipSize} from 'ui-library/chips/Chip';

interface AnonymousTagValueProps {
  typedValue: TypedValue;
}

export default function AnonymousTagValue({typedValue}: AnonymousTagValueProps): JSX.Element | null {
  if (typedValue.type === BaseTypedValueType.JSON) {
    const {tag} = typedValue.jsonValue;
    if (tag == null) {
      return null;
    }
    return (
      <TagValueViewer
        chipSize={ChipSize.TABLE_CELL}
        // Not supporting entity links yet but we definitely don't want them to be links as this is rendered
        // in a modal
        showChipsAsLinks={false}
        tag={tag}
      />
    );
  }
  return null;
}
